export default __webpack_public_path__ + "static/step-two-1cd1d061a4a4a67ae00b559077ddfe45.svg";